/**
 * Convert "my-cool-app" to "myCoolApp"
 */
export function kebabCaseToCamelCase(key: string) {
  return key
    .split("-")
    .map((s, i) => (i === 0 ? s : s[0].toUpperCase() + s.slice(1)))
    .join("");
}
